import { FunctionComponent } from 'react';
import {
    ConnectedProps,
    connectTicketDisplayCardContentSwitcher,
} from './connectTicketDisplayCardContentSwitcher';
import TicketDisplayCardContentSwitcher, {
    TicketDisplayCardContentSwitcherProps,
} from './TicketDisplayCardContentSwitcher';

export type ConnectedTicketDisplayCardContentSwitcherProps = Omit<
    TicketDisplayCardContentSwitcherProps,
    keyof ConnectedProps
>;
export default connectTicketDisplayCardContentSwitcher(
    TicketDisplayCardContentSwitcher,
) as FunctionComponent<ConnectedTicketDisplayCardContentSwitcherProps>;
